// Disable return types for import functions
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import SearchRadiologistPage from '@/views/search-radiologist-page.vue';

/** @see https://router.vuejs.org/fr/essentials/navigation.html for help */
export const routes = [
	{
		path: '/',
		name: 'search',
		component: SearchRadiologistPage
	},
	{
		path: '/maintenance',
		name: 'maintenance',
		component: () => import(
			/* webpackChunkName: "maintenance" */
			'@/views/maintenance-page.vue'
		)
	},
	{
		path: '*',
		name: 'notFound',
		component: () => import(
			/* webpackChunkName: "not-found" */
			'@/views/notfound-page.vue'
		)
	},
	{
		path: '/mentions-legales',
		name: 'legal-notices',
		component: () => import(
			/* webpackChunkName: "legal-notices" */
			'@/views/legal-notices-page.vue'
		),
		meta: { title: 'Mentions légales et CGU' }
	}
];